import React, { useState } from 'react'
import i18n from 'i18n-js'

import BaleDamage from './BaleDamage/BaleDamage'

import Input from '../UI/Input/Input'

import './BJ5Calculator.scss'

const BJ5Calculator = () => {

    const [fightSets, setFightSets] = useState({
        type: 'tel',
        id: 'fight',
        value: 0,
        label: i18n.t('fight_sets_label'),
        maxLength: 2
    })

    const [atkLeader, setAtkLeader] = useState({
        type: 'tel',
        id: 'atk_leader',
        value: 0,
        label: i18n.t('atk_leader_label'),
        maxLength: 2
    })

    // const [frontLine, setFrontLine] = useState({
    //     type: 'tel',
    //     id: 'frontline',
    //     value: 0,
    //     label: i18n.t('frontline_label'),
    //     maxLength: 2
    // })

    return <section className="BJ5Calculator">
        <h1 className="main-title">{i18n.t('bale_damage_title')}</h1>
        <div className="commons-wrapper">
            <Input {...fightSets} changed={evt => setFightSets({ ...fightSets, value: parseInt(evt.target.value || 0) })} />
            <Input {...atkLeader} changed={evt => setAtkLeader({ ...atkLeader, value: parseInt(evt.target.value || 0) })} />
            {/* <Input {...frontLine} changed={evt => setFrontLine({ ...frontLine, value: parseInt(evt.target.value || 0) })} /> */}
        </div>
        {/* frontLine={frontLine.value} */}
        <BaleDamage fightSets={fightSets.value} atkLeader={atkLeader.value} />
    </section>
}

export default BJ5Calculator